//swapi
export const BASE_URL = "https://swapi.dev/api/";
export const SWAPI_PEOPLE = "people";
export const SWAPI_PARAM_PAGE = "/?page=";
export const SWAPI_PARAM_SEARCH = '/?search='

export const API_PEOPLE = BASE_URL + SWAPI_PEOPLE;
export const API_SEARCH = BASE_URL + SWAPI_PEOPLE + SWAPI_PARAM_SEARCH

//starwars-visualguide.com

const GUIDE_IMG = "https://starwars-visualguide.com/assets/img/";

const GUIDE_PEOPLE = "characters/";
export const IMAGE_FORMAT = ".jpg";

export const URL_IMG_PERSON = GUIDE_IMG + GUIDE_PEOPLE;
